import * as z from "zod";

const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
const reqStrSchema = z.string().min(1, { message: "این فیلد الزامی است" });
const linkSchema = z.string().refine(
  (val) => {
    const regex = /^[a-zA-Z0-9\-]+[a-zA-Z0-9]$/;
    return regex.test(val);
  },
  {
    message: "این فیلد می تواند شامل حروف انگلیسی،اعداد و خط تیره باشد ولی نمی‌تواند با خط تیره پایان یابد",
  },
);
const reqNumSchema = z.number().refine((val) => val !== 0, { message: "این فیلد الزامی است" });

const datereqStrSchema = z.string().transform((val) => (val == null ? "" : val));

const dateSchema = datereqStrSchema
  .refine((val) => val !== "", {
    message: "این فیلد الزامی است",
  })
  .refine((val) => dateRegex.test(val), {
    message: "فرمت تاریخ نامعتبر است.",
  });

const attachmentSchema = z.object({
  url: z
    .string()
    .optional()
    .transform((e) => (e === undefined ? "" : e)),
  preview_url: z
    .string()
    .optional()
    .transform((e) => (e === undefined ? "" : e)),
});

export const authSchema = z.object({
  is_iranian: z.boolean(),
  first_name_fa: reqStrSchema,
  first_name_en: reqStrSchema,
  last_name_fa: reqStrSchema,
  last_name_en: reqStrSchema,
  father_name_fa: reqStrSchema,
  father_name_en: reqStrSchema,
  birthdate: dateSchema,
  national_code: z.string().min(1, { message: "این فیلد الزامی است" }).length(10, "کد ملی باید ده رقمی باشد"),
  email: z
    .string()
    .transform((val) => (val === "" ? null : val))
    .refine((val) => val === null || z.string().email().safeParse(val).success, {
      message: "فرمت ایمیل صحیح نمی باشد",
    }),
  profile_picture: z.object({
    url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e)),
    preview_url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e)),
  }),

  top_national_card_image: z.object({
    url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e)) // Transform undefined to empty string
      .refine((file) => file !== "", {
        message: `عکس کارت ملی الزامی است`,
      }),
    preview_url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e)) // Transform undefined to empty string
      .refine((file) => file !== "", {
        message: `عکس کارت ملی الزامی است`,
      }),
  }),
  first_birth_certificate_page_image: z.object({
    url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e)) // Transform undefined to empty string
      .refine((file) => file !== "", {
        message: `عکس شناسنامه الزامی است`,
      }),
    preview_url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e)) // Transform undefined to empty string
      .refine((file) => file !== "", {
        message: `عکس شناسنامه الزامی است`,
      }),
  }),
});

export const authForeingSchema = z.object({
  is_iranian: z.boolean(),
  first_name_fa: z.string().min(1, { message: "این فیلد الزامی است" }),
  first_name_en: z.string().min(1, { message: "این فیلد الزامی است" }),
  last_name_fa: z.string().min(1, { message: "این فیلد الزامی است" }),
  last_name_en: z.string().min(1, { message: "این فیلد الزامی است" }),
  father_name_fa: z.string().min(1, { message: "این فیلد الزامی است" }),
  father_name_en: z.string().min(1, { message: "این فیلد الزامی است" }),
  foreign_pervasive_code: z
    .string()
    .min(1, { message: "این فیلد الزامی است" })
    .length(12, "کد فراگیر باید دوازده رقمی باشد"),
  countrycode_id: z.union([
    z.string().min(1, { message: "این فیلد الزامی است" }),
    z.number().min(1, { message: "این فیلد الزامی است" }),
  ]),
  birthdate: dateSchema,
  passport_expire_date: dateSchema,
  email: z
    .string()
    .transform((val) => (val === "" ? null : val))
    .refine((val) => val === null || z.string().email().safeParse(val).success, {
      message: "فرمت ایمیل صحیح نمی باشد",
    }),
  passport_number: z
    .string()
    .min(1, { message: "این فیلد الزامی است" })
    .length(9, " شماره گذرنامه باید 8 رقمی باشد"),
  profile_picture: z.object({
    url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e)),
    preview_url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e)),
  }),
  passport_image: z.object({
    url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e))
      .refine((file) => file !== "", {
        message: `عکس گذرنامه الزامی است`,
      }),
    preview_url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e))
      .refine((file) => file !== "", {
        message: `عکس گذرنامه الزامی است`,
      }),
  }),
});

export const ticketSchema = z.object({
  title: z.string().min(1, { message: "این فیلد الزامی است" }).max(500, "تعداد کاراکتر مجاز 500 است"),
  ticketcategory_id: z.string().min(1, { message: "این فیلد الزامی است" }),
  ticketpriority_id: z.string().min(1, { message: "این فیلد الزامی است" }),
  description: z.string().min(1, { message: "این فیلد الزامی است" }).max(5000, "تعداد کاراکتر مجاز 5000 است"),
  attachments: z.array(attachmentSchema),
});
export const gatewaySchema = z
  .object({
    website_fa: z.string().min(1, { message: "این فیلد الزامی است" }),
    website_en: z.string().min(1, { message: "این فیلد الزامی است" }),
    field: z.string().min(3, { message: " حداقل 3 کاراکتر الزامی است" }),
    description: z.string(),
    gatewayType: z.string().min(1, { message: "این فیلد الزامی است" }),
    gatewayAddress: z.string().min(1, { message: "این فیلد الزامی است" }),
  })
  .superRefine((data, ctx) => {
    // Combine gatewayType and gatewayAddress to form the full URL
    const combinedAddress = `${data.gatewayType}://${data.gatewayAddress}`;

    let regex = new RegExp(
      "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z\\-\\.]+)+(\\.[a-zA-Z]{2,6})+(/[a-zA-Z0-9\\-\\.\\/?]*)?$",
    );

    if (!regex.test(combinedAddress)) {
      ctx.addIssue({
        path: ["gatewayAddress"],
        message: "آدرس url نامعتبر است",
      });
    } else {
    }
  });

export const realBussinessShema = z.object({
  is_real: z.boolean(),
  fa_name: reqStrSchema,
  en_name: reqStrSchema,
  address: reqStrSchema,
  phone: z.string().min(1, { message: "این فیلد الزامی است" }).length(11, " شماره تلفن باید 11 رقمی باشد"),
  postal_code: z.string().min(1, { message: "این فیلد الزامی است" }).length(10, "کد پستی باید ده رقمی باشد"),

  tax_code: z
    .union([
      z.string().length(10, "کدمالیاتی 10 رقمی است."),
      z.string().length(0), // Empty string
    ])
    .transform((e) => (e === undefined ? "" : e)),
  account_id: reqNumSchema,
  category_id: reqNumSchema,
  logo: z.object({
    url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e)),
    preview_url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e)),
  }),
  business_license_image: z.object({
    url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e)),
    preview_url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e)),
  }),
});

export const legalBussinessShema = z.object({
  is_real: z.boolean(),
  fa_name: reqStrSchema,
  en_name: reqStrSchema,
  address: reqStrSchema,
  phone: z.string().min(1, { message: "این فیلد الزامی است" }).length(11, " شماره تلفن باید 11 رقمی باشد"),
  postal_code: z.string().min(1, { message: "این فیلد الزامی است" }).length(10, "کد پستی باید ده رقمی باشد"),

  tax_code: z
    .string()
    .length(10, "کدمالیاتی 10 رقمی است.")
    .transform((e) => (e === undefined ? "" : e)),
  account_id: reqNumSchema,
  category_id: reqNumSchema,
  register_code: z
    .string()
    .min(4, { message: "کد ثبت باید حداقل 4 رقم باشد" })
    .max(6, { message: "کد ثبت نباید بیشتر از 6 رقم باشد" })
    .regex(/^\d+$/, { message: "کد ثبت باید فقط شامل اعداد باشد" }),
  register_date: dateSchema,
  national_id: z
    .string()
    .min(10, { message: "شناسه ملی باید حداقل 10 رقم باشد" })
    .max(12, { message: "شناسه ملی نباید بیشتر از 12 رقم باشد" })
    .regex(/^\d+$/, { message: "شناسه ملی باید فقط شامل اعداد باشد" }),

  logo: z.object({
    url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e)),
    preview_url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e)),
  }),

  business_license_image: z.object({
    url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e)),
    preview_url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e)),
  }),
  announcement_image: z.object({
    url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e))
      .refine((file) => file !== "", {
        message: `عکس آگهی تاسیس الزامی است`,
      }),
    preview_url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e))
      .refine((file) => file !== "", {
        message: `عکس آگهی تاسیس الزامی است`,
      }),
  }),
  last_announcement_image: z.object({
    url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e))
      .refine((file) => file !== "", {
        message: `عکس آگهی آخرین تغییرات الزامی است`,
      }),
    preview_url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e))
      .refine((file) => file !== "", {
        message: `عکس آگهی آخرین تغییرات الزامی است`,
      }),
  }),
});

export const portSchema = z
  .object({
    fixed_amount: z.boolean(),
    form_amount: z
      .string()
      .optional()
      .refine(
        (value) => {
          if (value) {
            const cleanValue = value.replace(/,/g, "").trim(); // Remove commas and extra spaces
            const numberValue = Number(cleanValue);
            return numberValue >= 10000 && numberValue <= 1000000000;
          }
          return true;
        },
        {
          message: "مبلغ باید مابین 10,000 و 1,000,000,000 ریال باشد",
        },
      ),
    display_payer_name: z.boolean(),
    is_payer_name_mandatory: z.boolean(),
    display_payer_phone: z.boolean(),
    is_payer_phone_mandatory: z.boolean(),
    display_payer_email: z.boolean(),
    is_payer_email_mandatory: z.boolean(),
    display_payer_address: z.boolean(),
    is_payer_address_mandatory: z.boolean(),
    is_expendable: z.boolean(),
    expire_time: z.string().nullable(),
    display_expire_time: z.boolean(),
    has_target_amount: z.boolean(),
    target_amount: z
      .string()
      .optional()
      .refine(
        (value) => {
          if (value) {
            const cleanValue = value.replace(/,/g, "").trim(); // Remove commas and extra spaces
            const numberValue = Number(cleanValue);
            return numberValue >= 10000 && numberValue <= 10000000000;
          }
          return true;
        },
        {
          message: "مبلغ باید مابین 10,000 و 10,000,000,000 ریال باشد",
        },
      ),
    display_target_amount: z.boolean(),
    is_wage_on_owner: z.boolean(),
    display_wage_payer: z.boolean(),

    display_national_code: z.boolean(),
    is_national_code_mandatory: z.boolean(),
    display_postal_code: z.boolean(),
    is_postal_code_mandatory: z.boolean(),
    name: reqStrSchema,
    link: linkSchema,
    image: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e))
      .refine((file) => file !== "", {
        message: `عکس اطلاعات فرم الزامی است`,
      }),
    description: reqStrSchema,
  })
  .superRefine((data, ctx) => {
    if (
      data.is_expendable &&
      (data.expire_time === null || data.expire_time === undefined, data.expire_time === "")
    ) {
      ctx.addIssue({
        path: ["expire_time"],
        message: "در صورت زمان دار بودن فرم انتخاب تاریخ انقضا الزامی  است.",
      });
    }
  })
  .superRefine((data, ctx) => {
    if (
      data.fixed_amount &&
      (data.form_amount === null || data.form_amount === undefined || data.form_amount === "")
    ) {
      ctx.addIssue({
        path: ["form_amount"],
        message: "درصورت ثابت بودن مبلغ فرم ،مبلغ الزامی است",
      });
    }
  })
  .superRefine((data, ctx) => {
    if (
      data.has_target_amount &&
      (data.target_amount === null || data.target_amount === undefined || data.target_amount === "")
    ) {
      ctx.addIssue({
        path: ["target_amount"],
        message: "درصورت ثابت بودن مبلغ فرم ،مبلغ الزامی است",
      });
    }
  });

export const settlementSchema = z
  .object({
    settlement_type: z.union([z.string(), z.number()]),
    settlement_schedule: z.union([z.string(), z.number()]),
    secondaryOption: z.union([z.string(), z.number()]).nullable(),
  })
  .refine(
    (data) => {
      //console.log(data.settlement_schedule, "data.settlement_schedule");

      if (data.settlement_schedule == 2) {
        return data.secondaryOption !== null && data.secondaryOption >= 1 && data.secondaryOption <= 7;
      }
      return true;
    },
    {
      message: "یک رور هفته را انتخاب نمایید",
      path: ["secondaryOption"],
    },
  )
  .refine(
    (data) => {
      if (data.settlement_schedule == 3) {
        return data.secondaryOption !== null && data.secondaryOption >= 6 && data.secondaryOption <= 26;
      }
      return true;
    },
    {
      message: "یک روز ماه را انتخاب نمایید",
      path: ["secondaryOption"],
    },
  );

export const paymentFormSchema = z.object({
  payer_name: z.string().min(1, { message: "نام پرداخت کننده الزامی است" }),

  payer_mobile: z
    .string()
    .min(1, { message: "شماره همراه  الزامی است" })
    .length(10, "کد شماره تلفن باید 11 رقمی باشد"),
  payer_postal_code: z
    .string()
    .min(1, { message: "کدپستی الزامی است" })
    .length(10, "کد پستی باید ده رقمی باشد"),
  payer_national_code: z
    .string()
    .min(1, { message: "کدپستی الزامی است" })
    .length(10, "کد ملی باید ده رقمی باشد"),
  payer_mail: z
    .string()
    .min(1, { message: " ایمیل  الزامی است" })
    .transform((val) => (val === "" ? null : val))
    .refine((val) => val === null || z.string().email().safeParse(val).success, {
      message: "فرمت ایمیل صحیح نمی باشد",
    }),
});
